import { render } from "./profileView.vue?vue&type=template&id=475ae91c&scoped=true"
import script from "./profileView.vue?vue&type=script&lang=js"
export * from "./profileView.vue?vue&type=script&lang=js"

import "./profileView.vue?vue&type=style&index=0&id=475ae91c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475ae91c"]])

export default __exports__